import { useQuery } from '@apollo/client';
import { productPrice, productPriceVariables } from 'src/queries/__generated__/productPrice';
import { DEFAULT_PRICE } from 'src/types/global-types';
import productPriceQuery from 'src/queries/productPrice.graphql';
import { cleanBundlePrice } from 'src/components/ProductDetail/utils/product-detail.types';
import { useCurrencyChange } from 'src/components/AppShell/ConfigProvider';

export const useWeareBundlePrices = (id: number) => {
    const { data, refetch } = useQuery<productPrice, productPriceVariables>(productPriceQuery, {
        variables: { asIntArray: [id] },
    });

    useCurrencyChange(refetch);

    if (!data) return DEFAULT_PRICE;

    return cleanBundlePrice(data?.productPrice);
};
